import React from "react";
import BaseSocialButton from "./BaseSocialButton";
import AppleIcon from "./icons/AppleIcon";

interface AppleSocialButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  text?: string;
  loading?: boolean;
}

const AppleSocialButton: React.FC<AppleSocialButtonProps> = React.memo(({
  onClick,
  disabled = false,
  className = "",
  text = "Continue with Apple",
  loading = false,
}) => {
  return (
    <BaseSocialButton
      onClick={onClick}
      disabled={disabled}
      className={className}
      loading={loading}
      variant="apple"
      icon={<AppleIcon />}
    >
      {text}
    </BaseSocialButton>
  );
});

AppleSocialButton.displayName = "AppleSocialButton";

export default AppleSocialButton;
